import React, {Component} from 'react';
import MarkdownLoader from './MarkdownLoader';
import {connect} from 'react-redux';

class ProgramDetailsReports extends Component {
    render() {
        return (
            <MarkdownLoader source={this.props.program_reports_page}/>
        );
    }
}

function mapStateToProps(state) {
    return {
        program_reports_page: state.settings.program_reports_page || '/program_reports.html'
    }
}


export default connect(mapStateToProps)(ProgramDetailsReports);
